import React from 'react';
import propTypes from 'prop-types';
import { Routes, Route } from 'react-router-dom';
import { LoansListPage } from './LoansListPage';
import { LoansEditPage } from './LoansEditPage';

export function LoansPage({ loan, isExpanded }) {
  return (
    <Routes loan={loan}>
      <Route
        path="/"
        exact
        element={<LoansListPage isExpanded={isExpanded} />}
      />
      <Route path="/add" element={<LoansEditPage isExpanded={isExpanded} />} />
      <Route
        path="/edit/:id"
        element={<LoansEditPage loan={loan} isExpanded={isExpanded} />}
      />
    </Routes>
  );
}

LoansPage.propTypes = {
  loan: propTypes.object.isRequired,
  isExpanded: propTypes.bool.isRequired,
};
